import { render, staticRenderFns } from "./UserConsentsModal.vue?vue&type=template&id=7aa1cce0&scoped=true&"
import script from "./UserConsentsModal.vue?vue&type=script&lang=js&"
export * from "./UserConsentsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserConsentsModal.vue?vue&type=style&index=0&id=7aa1cce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa1cce0",
  null
  
)

export default component.exports